import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import useStyles from "./styles";
import { Box } from "@mui/material";

interface CarouselProps {
  image: string;
  title: string;
  desc: string
}

interface CarouselComponentProps {
  items: CarouselProps[];  // Este es el arreglo de elementos que el componente recibirá
}

const Carousel: React.FC<CarouselComponentProps> = ({ items }) => {
  const classes = useStyles();

  const settings = {
    dots: true, // Muestra los indicadores inferiores
    infinite: true, // Hace que el carrusel sea infinito
    speed: 500, // Velocidad de transición
    slidesToShow: 3, // Muestra 3 elementos a la vez
    slidesToScroll: 1, // Se mueve de a un elemento
    autoplay: true, // Activar auto reproducción
    autoplaySpeed: 2000, // Tiempo entre transiciones
    arrows: true, // Flechas de navegación
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div className="max-w-4xl mx-auto p-4">
      <Slider {...settings}>
        {items.map((num, idx) => (

          <div key={idx} className="p-4">
            <Box className={classes.gridItem}>
              <div className={classes.imageWrapper}>
                <img className={classes.image} src={num.image} alt="Optimización instante" />
              </div>
              <p className={classes.title}>{num.title}</p>
              <p className={classes.description}>
                {num.desc}
              </p>
            </Box>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default Carousel;
